module.exports = __webpack_public_path__ + "img/19_82.4cf31bfd.png";